import { Dispatch, SetStateAction } from "react";
import { assets, colors, colorsRGB, fontWeights } from "./constants";
import { Shopify } from "@state/types";
import { MailingAddress } from "shopify-storefront-api-typings";

export type Dimensions = {
  width?: string;
  height?: string;
};

export type AssetsType = keyof typeof assets;

export type Asset = keyof typeof assets;
export type Color = keyof typeof colors;
export type ColorRGB = keyof typeof colorsRGB;
export type FontWeights = keyof typeof fontWeights;
export type AssetType = typeof assets;

export type SetRegion = Dispatch<
  SetStateAction<{
    iban: string;
    langCode: string;
  }>
>;

export type AnimationDirection = {
  to: {
    transform?: string;
    opacity?: number;
  };
  from: {
    transform?: string;
    opacity?: number;
  };
};

export function isSanityImage(data: any): data is Queries.SanityImage {
  return data._type === "image";
}

export function isSanityImageWithMeta(
  data: any
): data is Queries.SanityImageWithMeta {
  return data._type === "imageWithMeta";
}

export function isSanityMegaMenuLinks(
  data: any
): data is Queries.SanityMegaMenuLinks {
  return data._type === "megaMenuLinks";
}

export function isSanityImageTextBlock(
  data: any
): data is Queries.SanityImageTextBlock {
  return data._type === "imageTextBlock";
}

export function isSanityFullWidthContentCarousel(
  data: any
): data is Queries.SanityFullWidthContentCarousel {
  return data._type === "fullWidthContentCarousel";
}

export function isSanityFullWidthContent(
  data: any
): data is Queries.SanityFullWidthContent {
  return data._type === "fullWidthContent";
}

export function isSanityCategory(data: any): data is Queries.SanityCategory {
  return data._type === "category";
}

export function isSanityCollection(
  data: any
): data is Queries.SanityCollection {
  return data._type === "collection";
}

export function isSanityRecipe(data: any): data is Queries.SanityRecipe {
  return data._type === "recipe";
}

export function isSanityBlog(data: any): data is Queries.SanityBlog {
  return data._type === "blog";
}

export function isSanityGallery(data: any): data is Queries.SanityGallery {
  return data._type === "gallery";
}
export function isSanityImageGrid(data: any): data is Queries.SanityImageGrid {
  return data._type === "imageGrid";
}
export function isSanityTextCta(data: any): data is Queries.SanityTextCta {
  return data._type == "textCta";
}
export function isSanityHtml(data: any): data is Queries.SanityHtml {
  return data._type === "html";
}
export function isSanityTextLink(data: any): data is Queries.SanityTextLink {
  return data._type === "textLink";
}
export function isSanityFullWidthTextBlock(
  data: any
): data is Queries.SanityFullWidthTextBlock {
  return data._type === "fullWidthTextBlock";
}

export function isSanityProductBadge(
  data: any
): data is Queries.SanityProductBadge {
  return data._type === "productBadge";
}

export function isSanityAllergen(data: any): data is Queries.SanityAllergen {
  return data._type === "allergen";
}

export function isSanityBundles(data: any): data is Queries.SanityBundles {
  return data._type === "bundles";
}

export function isSanityProduct(data: any): data is Queries.SanityProduct {
  return data._type === "productAu" || data._type === "product";
}

export function isSanityVideo(data: any): data is Queries.SanityVideo {
  return data._type === "video";
}

export function isSanityTextColumn(
  data: any
): data is Queries.SanityTextColumn {
  return data._type === "textColumn";
}

export function isSanityJotform(data: any): data is Queries.SanityJotform {
  return data._type === "jotform";
}

export type AccountHandles =
  | "recipes"
  | "products"
  | "blogs"
  | "orders"
  | "preferences";
export interface CartLineItem {
  id: string;
  quantity: number;
}
export interface CheckoutLineItemInput {
  customAttributes?: LineItemAttributes[];
  quantity: number;
  variantId: string;
}
export interface LineItemAttributes {
  key: string;
  value: string;
}

export type PreferencesInput = "password" | "address" | "name" | "email";
export interface HandlePreferencesSubmitProps {
  type: PreferencesInput;
  inputArr: Element[];
  shopify: Shopify;
  setFocus: React.Dispatch<React.SetStateAction<string>>;
}
export interface PreferencesData {
  address?: MailingAddress;
  firstName?: string;
  lastName?: string;
  password?: string;
  confirmPassword?: string;
  email?: string;
}

export interface BreadcrumbPageContext {
  title: any;
  breadcrumb: {
    crumbs: Crumbs[];
  };
  iban: string;
  slug: string;
  shoudlFetchNZ: boolean;
  shouldFetchAU: boolean;
  // title?: string;
}

export interface Crumbs {
  crumbLabel: string;
  pathname: string;
}

export interface CartAttribute {
  key: string;
  value: string;
}

export interface StoreNewCartShopify {
  attributes: CartAttribute[];
}
